import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { HomePageRoutingModule } from './home-routing.module';

import { HomePage } from './home.page';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { HomeComponentsModule } from './home-components/home-components.module';
import { SectionsComponent } from './home-components/sections/sections.component';
import { GalleryComponentsModule } from 'src/app/gallery-components/gallery-components.module';
import { RecetasComponentsModule } from '../recetas/recetas-components/recetas-components.module';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { BranchComponentsModule } from 'src/app/components/change-branch/branch-components/branch-components.module';
import { SliderModule } from 'src/app/components/slider/slider.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    HomePageRoutingModule,
    GeneralesComponentsModule,
    HomeComponentsModule,
    GalleryComponentsModule,
    RecetasComponentsModule,
    PipeModule,
    BranchComponentsModule,
    SliderModule,
  ],
  declarations: [HomePage, SectionsComponent],
})
export class HomePageModule {}
